import axios from "axios";

const state = {
  icons: []
};

const actions = {
  getIcons: ({ commit }) => {
    return axios.get(`social-media-icons`)
      .then((resp) => {
        commit("getAllSocialMediaIcons", resp.data);
        return resp;
      });
  }
};

const mutations = {
  getAllSocialMediaIcons: (state, icons) => {
    icons.forEach(function(v, i) {
      state.icons.push(v);
    });
  }
};

export default {
  state,
  actions,
  mutations
};
